"use strict";

import angular from "angular";

import moment from "moment";
import template from "./card-insight.component.html";
import "./themes/card-insight.component.scss";
import "./themes/card-insight.component-dark.scss";

/**
 * @component NuCardInsightCtrl
 * O <nu-card-insight> is a component that is used for show insights Nanda
 */

class NuCardInsightCtrl {
    constructor() {}
    $onInit() {
        this.api = "https://api.whatsapp.com/send?text=";
        this.situationInsight = this.onGetSituation();
        this.state = 0;
        this.flipCard = false;
        this.insight.date = moment(this.insight.date).utcOffset(0);
    }
    like = ({ _id, like, comment, option, user } = {}, callback) => {
        this.onLike({ _id, like, comment, option, user, callback });
    };
    onGetSource = (source) =>
        source.toUpperCase() == "ACCOUNTING" ? "Contábil" : "Financeiro";
    onGetSituation = (insight = this.insight) => {
        let situation = "";
        if (insight.diagnosis != null) {
            situation = insight.diagnosis;
        } else {
            situation = insight.class;
        }
        return situation;
    };
    onGetLabel = (type, insight) => {
        let situation = {};
        let { serie, headline } = insight;
        const situations = {
            audit: {
                critical: {
                    label: "AUDITORIA CRÍTICA",
                    description: serie
                }
            },
            health: {
                good: {
                    label: "OBJETIVO ATINGIDO",
                    description: serie
                },
                bad: {
                    label: "LIMITE MÍNIMO ATINGIDO",
                    description: serie
                }
            },
            insight: {
                accounting: {
                    label: "INSIGHT CONTÁBIL",
                    description: `${headline}`
                },
                financial: {
                    label: "INSIGHT FINANCEIRO",
                    description: `${headline}`
                }
            }
        };
        if (type == "audit") {
            situation = situations["audit"][insight.diagnosis];
        } else if (type == "health") {
            situation = situations["health"][insight.diagnosis];
        } else {
            situation = situations["insight"][insight.source];
        }
        return situation;
    };
    onSetState = () => {
        if (this.state == 0) {
            this.state = 1;
        } else {
            this.state = 0;
        }
    };
}

NuCardInsightCtrl.$inject = [];

const name = "nuCardInsight";
const def = {
    bindings: {
        insight: "=",
        onLike: "=",
        onRemoved: "=",
        typeInsight: "=",
        onRemoveInsight: "="
    },
    controller: NuCardInsightCtrl,
    controllerAs: "cardInsightCtrl",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
